export const TABS = [
  {
    id: 'digitsSum',
    label: 'Suma de dígitos',
    fn: 'digitsSum(inputInt)',
    description:
      'Recibe un entero positivo y devuelve la suma de todos sus dígitos. ' +
      'Usa aritmética con % y Math.floor sin convertir a string.',
  },
  {
    id: 'isPalindrome',
    label: 'Palíndromo',
    fn: 'isPalindrome(inputStr)',
    description:
      'Verifica si un string se lee igual al derecho y al revés. ' +
      'Usa dos punteros (left/right) sin reverse() para mayor eficiencia.',
  },
  {
    id: 'integerSort',
    label: 'Ordenamiento',
    fn: 'integerSort(inputArray)',
    description:
      'Ordena un arreglo de enteros de menor a mayor con Bubble Sort. ' +
      'Devuelve un nuevo arreglo sin modificar el original.',
  },
];
